/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "DATA_ANALYTICS/LOADER_STATUS";
export const PROFILE_INFO = "DATA_ANALYTICS/PROFILE_INFO";
export const SET_VARIANCE_DATA = "DATA_ANALYTICS/SET_VARIANCE_DATA";

export const SET_LIAB_ITC = "RCM/SET_LIAB_ITC";
export const SET_TAX_RATE = "RCM/SET_TAX_RATE";
export const SET_TAX_TYPE = "RCM/SET_TAX_TYPE";
export const SET_CLEAR_GRAPH = "RCM/SET_CLEAR_GRAPH";
